import { createSlice } from '@reduxjs/toolkit';
import { login, logout, register } from './thunks';
import jwt from 'jwt-decode';
import { AuthState } from './state';
import { RolesOptions } from '../../domain/constants/Roles';

// Initial state for Redux store:
export const initialStateAuth: AuthState = {
  user: '',
  register: { email: '' },
  token: '',
  type: 3,
  name: '',
  role_name: '',
  id: '',
  loading: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState: initialStateAuth, // Define initial state
  reducers: {
    getUser: (state: any, action: any) => {
      state.loans = action.payload;
    },
    confirmRegister: (state: any, action: any) => {
      state.register.email = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(login.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(login.fulfilled, (state, action) => {
      state.loading = false;
      state.token = action.payload.token;
      const user: any = jwt(action.payload.token);
      state.type = user.roles_id;
      state.role_name =
        RolesOptions.find((r) => Number(r.id) === Number(user.roles_id))
          ?.name || 'Desconocido';
      state.name = user.name || '';
      state.user = action.payload.email || user?.email || '';
      state.id = user.id || '';
    });
    builder.addCase(login.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(register.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(register.fulfilled, (state, action) => {
      state.loading = false;
      state.register.email = action.payload;
    });
    builder.addCase(register.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(logout.fulfilled, (state, action) => {
      state.token = '';
      state.loading = false;
      state.type = 3;
    });
  },
});

// Export actions generated by "createSlice()":
export const { getUser } = authSlice.actions;

// Export reducer generated by "createSlice()":
export default authSlice.reducer;
